<template>
  <component
    :is="isLink ? 'router-link' : 'div'"
    :to="isLink ? to : null"
    class="app-kpi"
    :class="{ 'app-kpi--link': isLink, 'app-kpi--phone': isPhone }"
  >
    <span class="app-kpi__head">
      <app-icon v-if="icon" :name="icon" :size="16" class="app-kpi__icon" />
      <span class="app-kpi__title">{{ title }}</span>
      <span v-if="isLink" class="app-kpi__chev" aria-hidden="true"><app-icon name="chevR" :size="16" /></span>
    </span>
    <span class="app-kpi__card">
      <span class="app-kpi__value" :class="{ 'app-kpi__value--muted': state === 'error' || state === 'forbidden' }">
        <template v-if="state === 'loading'">
          <span class="app-kpi__placeholder" aria-hidden="true"></span><span class="app-sr-only">Wird geladen …</span>
        </template>
        <template v-else-if="state === 'error' || state === 'forbidden'">–</template>
        <slot v-else name="value" />
      </span>
      <span class="app-kpi__graphic" :style="graphicStyle">
        <span v-if="state === 'loading'" class="app-kpi__track" aria-hidden="true"></span>
        <slot v-else-if="isReady" name="graphic" />
      </span>
    </span>
    <span class="app-kpi__foot">
      <button
        v-if="state === 'error'"
        type="button"
        class="app-link app-link--inline"
        @click.prevent.stop="$emit('retry')"
      >Erneut versuchen</button>
      <span v-else-if="state === 'forbidden'" class="app-kpi__muted">Keine Berechtigung</span>
      <span v-else-if="state === 'loading'" class="app-skel app-kpi__foot-skel" aria-hidden="true"></span>
      <slot v-else-if="isReady" name="foot" />
    </span>
  </component>
</template>

<script>
// Kennzahl-Kachel als verschachtelte Karte (Kundenwunsch 12.10.2026; vorher Spezifikation 2.10): auf dem getönten,
// runden Rahmen oben der Kopf (Icon 16, Titel, › nur mit to) und unten die Fußzeile (links 500 --ink-2, rechts
// --ink-3), dazwischen die weiße Karte mit Wertzeile (26/34 600; Handy 20/26) und Grafikfeld (unten bündig).
// Slots: value (Euro-Teil als <span class="app-eur">€</span>), graphic (AppMiniBars/AppShareBar), foot (zwei Elemente:
// links, rechts; links optional <app-icon :size="13" />). state: 'loading' | 'ready' | 'error' | 'forbidden'.
// Im Fehlerzustand ist die Kachel kein Link (der Knopf „Erneut versuchen“ wäre sonst in einem Link verschachtelt).
// phone: Handy-Variante (Standard: automatisch über $dichte.handy). graphicHeight: Mindesthöhe des Grafikfelds,
// damit Laden und fertige Kachel gleich hoch sind (Minibalken 32/24, Anteilsbalken 6).
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppKpiTile',
  components: { AppIcon },
  props: {
    to: { type: [String, Object], default: null },
    icon: { type: String, default: null },
    title: { type: String, default: '' },
    state: { type: String, default: 'ready' },
    phone: { type: Boolean, default: null },
    graphicHeight: { type: [Number, String], default: null }
  },
  computed: {
    isPhone() {
      return this.phone === null ? !!(this.$dichte && this.$dichte.handy) : this.phone;
    },
    isReady() {
      return ['loading', 'error', 'forbidden'].indexOf(this.state) === -1;
    },
    isLink() {
      return !!this.to && this.state !== 'error';
    },
    graphicStyle() {
      const h = Number(this.graphicHeight);
      return h > 0 ? { minHeight: h + 'px' } : null;
    }
  }
};
</script>
